import { connect } from 'react-redux'
import { mainViewId } from 'redux/canvas/selectors'
import Default from './Default.jsx'

export const mapStateToProps = (state, props) => ({
    id: mainViewId,
})

export const DefaultContainer = connect(
    mapStateToProps
)(Default)
